import React from 'react';
import loadable from '@loadable/component';

const SafariList = loadable(() => import('../components/SafariList/SafariList'));

const SafarisPage = () => <SafariList />;

export default SafarisPage;